import React from 'react'
import { StyledBtn } from './styles'
import Icon from 'atoms/Icon'

const ButtonReg = props => (
  <StyledBtn
    disabled={props.disabled}
    btnType={props.btnType}
    {...props}
  >
    {props.btnIcon &&
      <Icon icon={props.btnIcon} color={props.btnIconColor} mr={'8%'} width={'14px'} />
    }
    {props.btnTxt}
  </StyledBtn>
)

export default ButtonReg
